import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModuloEnum } from '../../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../../shared/enums/usuario/funcionalidade.enum';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormaPagamentoService } from '../../../../shared/services/apis/financas/forma-pagamento.service';
import { FormaPagamento } from '../../../../shared/services/models/financas/forma-pagamento.model';
import { FormaPagamentoRequest } from '../../../../shared/services/requests/financas/forma-pagamento.request';
import { AlertService, AlertType } from '../../../../shared/services/alert.service';
import { Location } from '@angular/common';
import { HeaderComponent } from '../../../../shared/components/header/header.component';
import { LoadingBoxDefaultListComponent } from '../../../../shared/components/loading-box-default-list/loading-box-default-list.component';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-formas-pagamento',
    standalone: true,
    imports: [
        CommonModule,
        HeaderComponent,
        MatTableModule,
        MatIconModule,
        MatButtonModule,
        RouterModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
        LoadingBoxDefaultListComponent,
    ],
    templateUrl: './formas-pagamento.component.html',
    styleUrls: ['./formas-pagamento.component.css']
})
export class FormasPagamentoComponent implements OnInit {

    public moduloEnum = ModuloEnum.Configuracoes;
    public funcionalidadeEnum = FuncionalidadeEnum.Configuracoes_Financas;

    public dataSource: FormaPagamento[] = [];
    public displayedColumns: string[] = ['descricao', 'status', 'acoes'];
    public isLoading: boolean = true;
    public loadingItemId: number | null = null;

    constructor(
        private formaPagamentoService: FormaPagamentoService,
        private alertService: AlertService,
        public location: Location
    ) { }

    ngOnInit(): void {
        this.carregarDados();
    }

    public carregarDados(): void {
        this.isLoading = true;
        this.formaPagamentoService.get().subscribe({
            next: (response) => {
                this.isLoading = false;
                if (!response.isError) {
                    this.dataSource = response.listaFormaPagamento || [];
                } else {
                    this.alertService.show('Erro', response.errorDescription, AlertType.error);
                }
            },
            error: () => {
                this.isLoading = false;
                this.alertService.show('Erro', 'Erro ao buscar formas de pagamento.', AlertType.error);
            }
        });
    }

    public habilitar(item: FormaPagamento): void {
        this.atualizarStatus(item, true, item.isFavorito);
    }

    public desabilitar(item: FormaPagamento): void {
        if (item.isFavorito) return;
        this.atualizarStatus(item, false, item.isFavorito);
    }

    public favoritar(item: FormaPagamento): void {
        if (!item.isAtivo) return;
        this.atualizarStatus(item, item.isAtivo, true);
    }

    private atualizarStatus(item: FormaPagamento, isAtivo: boolean, isFavorito: boolean): void {
        this.loadingItemId = item.idFormaPagamento;

        const request: FormaPagamentoRequest = {
            isAtivo: isAtivo,
            isFavorito: isFavorito
        };

        this.formaPagamentoService.put(item.idFormaPagamento, request).subscribe({
            next: (response) => {
                this.loadingItemId = null;
                if (!response.isError) {
                    this.carregarDados();
                } else {
                    this.alertService.show('Erro', response.errorDescription, AlertType.error);
                }
            },
            error: () => {
                this.loadingItemId = null;
                this.alertService.show('Erro', 'Erro ao atualizar forma de pagamento.', AlertType.error);
            }
        });
    }
}
